module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "parag"
  }, [_c('em', [_vm._v("To the glory of God with thanksgiving"), _c('br'), _vm._v("for the wonder of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "parag"
  }, [_vm._v("     —Inscription on the grave of Eli Lilly,"), _c('br'), _vm._v("         Crown Hill Cemetery, Indianapolis")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e949be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 75
// module chunks = 0